import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=1552ff4a&"
import script from "./summary.vue?vue&type=script&lang=js&"
export * from "./summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1552ff4a')) {
      api.createRecord('1552ff4a', component.options)
    } else {
      api.reload('1552ff4a', component.options)
    }
    module.hot.accept("./summary.vue?vue&type=template&id=1552ff4a&", function () {
      api.rerender('1552ff4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tax-payer/summary.vue"
export default component.exports